import { ListingDataSuggestionState } from './types';

export const defaultState: ListingDataSuggestionState = {
  error: undefined,
  loading: {
    create: false
  }
};
